import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAlbums: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="albums, cover"><path d="M3.75 5.75V18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 4.75V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.75 20.25V3.75L20.25 5.29688V18.7031L11.75 20.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconAlbums;
